import AdminLayout from '@/layouts/AdminLayout.vue';
import EmptyLayout from '@/layouts/EmptyLayout.vue';
import adminOptionRoutes from './adminOptions';

export default [
  {
    path: '/admin',
    name: 'admin',
    component: AdminLayout,
    redirect: {
      name: 'admin-dashboard',
    },
    children: [
      {
        path: '/admin/dashboard',
        name: 'admin-dashboard',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/dashboard.vue'),
      },
      {
        path: '/admin/debtors',
        name: 'adminDebtors',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/debtors'),
      },
      {
        path: '/admin/debtors/:id',
        name: 'adminDebtorDetail',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/debtors/detail'),
      },
      {
        path: '/admin/debts',
        name: 'adminDebts',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/debts'),
      },
      {
        path: '/admin/debts/:id/edit',
        name: 'adminDebtsEdit',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/debts/edit.vue'),
      },
      {
        path: '/admin/stats',
        name: 'adminStats',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/stats'),
      },
      {
        path: '/admin/debt-tasks',
        name: 'adminDebtTasks',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/debt_tasks'),
      },
      {
        path: '/admin/payments',
        name: 'adminPayments',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/payments'),
      },
      {
        path: '/admin/calls/debtor',
        name: 'adminDebtorCalls',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/calls/debtor'),
      },
      {
        path: '/admin/calls/contactface',
        name: 'adminContactfaceCalls',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/calls/contactface'),
      },
      {
        path: '/admin/departures/debtor',
        name: 'adminDebtorDepartures',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/departures/debtor'),
      },
      {
        path: '/admin/departures/contactface',
        name: 'adminContactfaceDepartures',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/departures/contactface'),
      },
      {
        path: '/admin/import',
        name: 'adminImport',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/import'),
      },
      {
        path: '/admin/import/:id/report',
        name: 'adminImportReport',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/import/show.vue'),
      },
      {
        path: '/admin/old/import',
        name: 'adminOldImport',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/import/old'),
      },
      {
        path: '/admin/old/import/:id/report',
        name: 'adminOldImportReport',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/import/old/show.vue'),
      },
      {
        path: '/admin/docs/import',
        name: 'adminDocsImport',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/import/docs.vue'),
      },
      {
        path: '/admin/ffins',
        name: 'adminFFins',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/ffins'),
      },
      {
        path: '/admin/ffins/:id',
        name: 'adminFFinsDetail',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/ffins/detail.vue'),
      },
      {
        path: '/admin/export',
        name: 'adminExport',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/export'),
      },
      {
        path: '/admin/users',
        name: 'adminUsers',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/users'),
      },
      {
        path: '/admin/users/:id/view',
        name: 'adminUsersEdit',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/users/view.vue'),
      },
      {
        path: '/admin/teams',
        name: 'adminTeams',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/teams'),
      },
      {
        path: '/admin/contragents',
        name: 'adminContragents',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/contragents'),
      },
      {
        path: '/admin/whitelistip',
        name: 'adminWhitelistip',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/whitelistip'),
      },
      {
        path: '/admin/roles',
        name: 'adminRoles',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/roles'),
      },
      {
        path: '/admin/permissions',
        name: 'adminPermissions',
        meta: {
          requiresAuth: true,
        },
        component: () => import('../views/admin/permissions'),
      },
      {
        path: '/admin/options',
        name: 'adminOptions',
        component: EmptyLayout,
        redirect: {
          name: 'admin-dashboard',
        },
        children: adminOptionRoutes,
      },
    ],
  },
];
